import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBaOZrb5w-qMAV8Xj1JhZMWkTr2nBBhlyU",
  authDomain: "stronger-and-free.firebaseapp.com",
  projectId: "stronger-and-free",
  storageBucket: "stronger-and-free.firebasestorage.app",
  messagingSenderId: "778685700898",
  appId: "1:778685700898:web:0a37fa67ad4f86607da37b",
  measurementId: "G-R1ZHSMBQ7L"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
